export default __webpack_public_path__ + "static/media/team-members.e3e7bbb1.svg";